// import { createPopper } from '@popperjs/core';
import tippy from 'tippy.js';

export default function() {

  document.querySelectorAll('[title][class*="icon-"]').forEach((el) => {
    // Bootstrap Tooltips
    // if ($.fn.tooltip) {
    //   $body.tooltip({
    //     selector: '[title][class*="icon-"]',
    //     position: 'top',
    //     container: 'body'
    //   });
    // }
    tippy(el, {
      content: el.dataset.content,
      placement: el.dataset.placement || 'top',
      allowHTML: el.dataset.html,
      theme: 'translucent',
    });
  });

  document.querySelectorAll('[data-toggle="popover"]').forEach((el) => {
    // Bootstrap Popovers
    // if ($.fn.popover) {
    //   $('[data-toggle="popover"]').popover({
    //     container: 'body',
    //     trigger: 'hover'
    //   });
    // }
    let trigger = el.dataset.trigger;
    if (trigger === 'hover') {
      trigger = 'mouseenter focus';
    }
    tippy(el, {
      content: el.dataset.content,
      placement: el.dataset.placement,
      allowHTML: el.dataset.html,
      theme: 'translucent',
      trigger,
    });
  });
}
